import { Fragment } from 'react'
import { Box } from '@careguide/theme'
import IconWithText from 'components/generic/IconWithText'

import { ListingFacet } from 'types/listing-facet'
import { getListingFacetCopy } from 'utils/generalUtils'
import { Facet } from './ListingFacet.styles'
import { Body } from '@careguide/typography'
import Stack from '@careguide/stack'

type ListingFacetProps = {
  facets: Array<ListingFacet>
}

const ListingFacets = ({ facets }: ListingFacetProps) => (
  <Box display='flex' flexDirection='row' flexWrap='wrap'>
    {facets.map(({ key, label, text, supportingData, imageName, blurbs }) => {
      let copy = getListingFacetCopy(label, text, supportingData)
      const imageUrl = imageName ? `/images/facet/${imageName}` : '/images/facet/bullet.svg'
      const hasBlurbs = blurbs?.length > 0

      return (
        <Fragment key={key}>
          {copy && (
            <Facet>
              <IconWithText
                text={copy}
                iconUrl={imageUrl}
                // Intentionally blank to hide from screen-readers.
                iconAlt=''
                iconDimension={{ height: '16px', width: '16px' }}
              />
            </Facet>
          )}
          {hasBlurbs && (
            <Stack gap='2'>
              {blurbs.map((blurb, i) => (
                <Body key={i}>{blurb}</Body>
              ))}
            </Stack>
          )}
        </Fragment>
      )
    })}
  </Box>
)

export default ListingFacets
